import React, { forwardRef, Ref } from "react";
import {
  TkSearchFormItemProps,
  TkSearchFormItemType,
} from "../../../type/componentsType/TkSearchFormItem";
import TkLabelText from "../TkLabelText";
import { TkSelectForm } from "../TkSelectForm";
import { TkSelectProps } from "../../../type/componentsType/TkSelectForm";
import "./_style.scss";

/**
 * TkSearchFormItemコンポーネントは、検索フォーム内の各項目を表示するためのコンポーネントです。
 *
 * @param props TkSearchFormItemのプロパティ
 * @param props.type TkSearchFormItemのタイプ
 * @param props.errorMessage エラーメッセージ
 * @param props.selectPropsList 選択フォームのプロパティリスト
 * @param ref domの参照
 *
 * @returns TkSearchFormItemコンポーネント
 */
const TkSearchFormItem = forwardRef<
  any,
  TkSearchFormItemProps<TkSearchFormItemType>
>((props, ref: Ref<any>) => {
  const { type, onChange } = props;

  let selectList: TkSelectProps[] = [];

  const typeMap = (type: TkSearchFormItemType) => {
    if (type === "label") {
      const { errorMessage, getChangeValue, ...rest } =
        props as TkSearchFormItemProps<"label">;

      return (
        <TkLabelText
          variant="standard"
          {...rest}
          className="tkSearchFromItem tkLabelInSearchFromItem"
          error={!!errorMessage}
          helperText={errorMessage}
          onGetInputValue={getChangeValue}
          onChange={(e: any) => {
            getChangeValue(e.target.value);
            onChange &&
              onChange({
                target: {
                  value: e.target.value,
                },
              });
          }}
        />
      );
    } else if (type === "selectFrom") {
      const { errorMessage, getChangeValue, ...rest } =
        props as TkSearchFormItemProps<"selectFrom">;

      selectList = rest.selectPropsList || [];

      return (
        <TkSelectForm
          {...rest}
          className="tkSearchFromItem tkSelectFromInSearchFromItem"
          selectPropsList={selectList}
          error={!!errorMessage}
          errorMessage={errorMessage}
          ref={ref}
          onChange={(e: any) => {
            getChangeValue(e.target.value);
            onChange &&
              onChange({
                target: {
                  value: e.target.value,
                },
              });
          }}
        />
      );
    }
  };

  const RenderComponent = typeMap(type);

  return <>{RenderComponent}</>;
});

export default TkSearchFormItem;
